// imports
import { Outlet, Link, useNavigate, NavLink } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";

// components
import Sidebar from "./components/Sidebar";
import OnlineUsers from "./components/OnlineUsers";
import SettingsSidebar from "./components/SettingsSideBar";

// styles and images
import "./App.css";
import Expand from "./assets/expand.svg";
import Collapse from "./assets/collapse.svg";
import MessageCard from "./components/MessageCard";

// store
import {
  accountDataStore,
  awsDataStore,
  dbDataStore,
  externalStore,
  messageAndErrorStore,
  userStore,
} from "./store/Store";

function App() {
  // global state
  const setJwtToken = userStore((userDataStore) => userDataStore.setJwtToken);
  const setCurrentUser = userStore(
    (userDataStore) => userDataStore.setCurrentUser,
  );
  const setCurrentCompany = userStore(
    (userDataStore) => userDataStore.setCurrentCompany,
  );
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const currentCompany = userStore(
    (userDataStore) => userDataStore.currentCompany,
  );
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const setAuthStatus = userStore((messages) => messages.setAuthStatus);
  const showSettings = userStore((messages) => messages.showSettings);
  const setShowSettings = userStore((messages) => messages.setShowSettings);
  const messageTrigger = messageAndErrorStore(
    (messages) => messages.messageTrigger,
  );
  const pageError = messageAndErrorStore((messages) => messages.error);
  const authError = messageAndErrorStore((messages) => messages.authError);
  const authStatus = userStore((messages) => messages.authStatus);
  const setError = messageAndErrorStore((messages) => messages.setError);
  const successMessage = messageAndErrorStore(
    (messages) => messages.successMessage,
  );
  const setPending = messageAndErrorStore((messages) => messages.setPending);
  const setAuthError = messageAndErrorStore(
    (messages) => messages.setAuthError,
  );
  const toggleNewMessage = messageAndErrorStore(
    (data) => data.toggleNewMessage,
  );
  const setTypesData = dbDataStore((dbData) => dbData.setTypesData);
  const setCompanyData = dbDataStore((dbData) => dbData.setCompanyData);
  const setGlobalCompanyNames = dbDataStore(
    (dbData) => dbData.setGlobalCompanyNames,
  );
  const setRateSheetData = dbDataStore((dbData) => dbData.setRateSheetData);
  const setTieredRateSheets = dbDataStore(
    (dbData) => dbData.setTieredRateSheets,
  );
  const setFuelSurchargeData = dbDataStore(
    (dbData) => dbData.setFuelSurchargeData,
  );
  const setAssetRateSheets = dbDataStore((dbData) => dbData.setAssetRateSheets);
  const setProjectData = dbDataStore((dbData) => dbData.setProjectData);
  const setUsers = dbDataStore((dbData) => dbData.setUsers);
  const users = dbDataStore((dbData) => dbData.users);
  const setCompanyLists = dbDataStore((data) => data.setCompanyLists);
  const setProfilePic = awsDataStore((awsData) => awsData.setProfilePic);
  const setUserProfiles = awsDataStore((awsData) => awsData.setUserProfiles);
  const setFscArea = externalStore((exData) => exData.setFscArea);
  const setPropConnectJobs = externalStore(
    (exData) => exData.setPropConnectJobs,
  );
  const setAccountCustomerInvoices = accountDataStore(
    (data) => data.setAccountCustomerInvoices,
  );
  const setAccountCustomerInvoiceTotals = accountDataStore(
    (data) => data.setAccountCustomerInvoiceTotals,
  );
  const setAccountVendorInvoices = accountDataStore(
    (data) => data.setAccountVendorInvoices,
  );
  const setAccountVendorInvoiceTotals = accountDataStore(
    (data) => data.setAccountVendorInvoiceTotals,
  );

  // local
  // const [showSettings, setShowSettings] = useState(false);
  const [showTeam, setShowTeam] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [fscPending, setFscPending] = useState(false);
  const [tickInterval, setTickInterval] = useState();
  const navigate = useNavigate();

  // helper funcs
  const getUserPic = (text) => {
    const urlPattern = /(blob:http:\/\/localhost:3000\/[a-f0-9-]+)/;
    const match = text.match(urlPattern);

    if (match && match[1]) {
      return match[1];
    } else {
      return null;
    }
  };

  // get data
  useEffect(() => {
    setPending(true);
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${JwtToken}`);
    headers.append("Content-Type", "application/json");
    const requestOptions = {
      method: "GET",
      headers: headers,
      signal: controller.signal,
    };
    if (JwtToken && currentCompany && authStatus) {
      fetch(`${process.env.REACT_APP_BACKEND}/lc/dbtypes`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          setTypesData(data);
        })
        .catch((err) => {
          console.log(err);
        });
      if (currentCompany.full_access) {
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/account-companies`,
          requestOptions,
        )
          .then((response) => {
            if (response.status === 401) {
              navigate("/login");
              setAuthStatus(false);
            } else {
              setAuthStatus(true);
              return response.json();
            }
          })
          .then((data) => {
            setCompanyData(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/company-lists`,
          requestOptions,
        )
          .then((response) => {
            if (response.status === 401) {
              navigate("/login");
              setAuthStatus(false);
            } else {
              setAuthStatus(true);
              return response.json();
            }
          })
          .then((data) => {
            setCompanyLists(data);
          })
          .catch((err) => {
            console.log(err);
          });

        fetch(`${process.env.REACT_APP_BACKEND}/pc/companies`, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            setGlobalCompanyNames(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=false`,
          requestOptions,
        )
          .then((response) => response.json())
          .then((data) => {
            setRateSheetData(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/rate-sheets?is_tiered=true`,
          requestOptions,
        )
          .then((response) => response.json())
          .then((data) => {
            setTieredRateSheets(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/fsc-rate-sheets`,
          requestOptions,
        )
          .then((response) => response.json())
          .then((data) => {
            setFuelSurchargeData(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/asset-rate-sheets`,
          requestOptions,
        )
          .then((response) => response.json())
          .then((data) => {
            setAssetRateSheets(data);
          })
          .catch((err) => {
            console.log(err);
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/projects/${currentCompany.id}`,
          requestOptions,
        )
          .then((res) => res.json())
          .then((data) => {
            setProjectData(data);
          })
          .catch((_) => {
            setError("Could get project data.");
            return;
          });
        fetch(`${process.env.REACT_APP_BACKEND}/pc/pc-jobs`, requestOptions)
          .then((res) => res.json())
          .then((data) => {
            setPropConnectJobs(data);
          })
          .catch((_) => {
            setError("Could not get jobs from PropConnect");
            return;
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/account-customer-invoices`,
          requestOptions,
        )
          .then((res) => res.json())
          .then((data) => {
            setAccountCustomerInvoices(data.customer_invoices);
            setAccountCustomerInvoiceTotals(data.customer_invoice_totals);
          })
          .catch((_) => {
            setError("Could not get Account Customer Invoices");
            return;
          });
        fetch(
          `${process.env.REACT_APP_BACKEND}/pc/account-vendor-invoices`,
          requestOptions,
        )
          .then((res) => res.json())
          .then((data) => {
            setAccountVendorInvoices(data.vendor_invoices);
            setAccountVendorInvoiceTotals(data.vendor_invoice_totals);
          })
          .catch((_) => {
            setError("Could not get Account Vendor Invoices");
            return;
          });
      }

      fetch(
        `${process.env.REACT_APP_BACKEND}/lc/get-file/${
          currentUser.id
        }/${"profile-pics"}/{jpeg}?user_id=${currentUser.id}`,
        requestOptions,
      )
        .then((res) => {
          if (!res.ok) {
            setProfilePic(null);
          } else {
            return res.blob();
          }
        })
        .then((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            setProfilePic(url);
          } else {
            setProfilePic(null);
          }
        })
        .catch((err) => {
          console.log(err);
          return;
        });
      return () => {
        controller.abort();
      };
    } else {
      navigate("/login");
    }
    setPending(false);
  }, [
    JwtToken,
    currentUser,
    setCompanyData,
    setGlobalCompanyNames,
    setProfilePic,
    setFuelSurchargeData,
    setRateSheetData,
    setTieredRateSheets,
    setAssetRateSheets,
    setTypesData,
    setError,
    setFscArea,
    setProjectData,
    navigate,
    setPending,
    currentCompany,
    setPropConnectJobs,
    setAuthStatus,
    authStatus,
    setCompanyLists,
    setAccountVendorInvoices,
    setAccountCustomerInvoices,
    setAccountCustomerInvoiceTotals,
    setAccountVendorInvoiceTotals,
  ]);

  useEffect(() => {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${JwtToken}`);
    headers.append("Content-Type", "application/json");
    const requestOptions = {
      method: "GET",
      headers: headers,
    };
    if (JwtToken && currentCompany && currentCompany.full_access) {
      setFscPending(true);
      fetch(`${process.env.REACT_APP_BACKEND}/pc/get-fsc-area`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            toggleNewMessage("Could not get FSC Areas from EIA API");
            setFscPending(false);
          } else {
            setFscArea(data);
            setFscPending(false);
          }
        })
        .catch((_) => {
          toggleNewMessage("Could not retrieve FSC Area.");
          setFscPending(false);
          return;
        });
    }
  }, [toggleNewMessage, JwtToken, currentCompany, setFscArea]);

  // users and profile pics
  useEffect(() => {
    if (JwtToken) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${JwtToken}`);
      headers.append("Content-Type", "application/json");
      const requestOptions = {
        method: "GET",
        headers: headers,
      };
      fetch(`${process.env.REACT_APP_BACKEND}/lc/users`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          setUsers(data);
        })
        .catch((_) => {
          setError("Could not get users");
        });
    }
  }, [currentCompany, JwtToken, setUsers, setError]);

  // get profile pics of all users
  useEffect(() => {
    if (users && JwtToken && !users.error) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${JwtToken}`);
      const requestOptions = {
        method: "GET",
        headers: headers,
      };
      const profiles = {};
      users.forEach((u) => {
        if (u.photo_url) {
          fetch(
            `${process.env.REACT_APP_BACKEND}/lc/get-file/${
              u.id
            }/${"profile-pics"}/{jpeg}?user_id=${currentUser.id}`,
            requestOptions,
          )
            .then((res) => {
              if (!res.ok) {
                return Promise.resolve();
              } else {
                return res.blob();
              }
            })
            .then((blob) => {
              if (!blob) {
                profiles[u.id] = null;
              } else {
                const url = URL.createObjectURL(blob);
                profiles[u.id] = getUserPic(url);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
      setUserProfiles(profiles);
    }
  }, [users, JwtToken, setUserProfiles, currentCompany, currentUser]);

  const logout = () => {
    setIsPending(true);
    const requestOptions = {
      method: "GET",
      credentials: "include",
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/logout/${currentUser.id}`,
      requestOptions,
    )
      .catch((error) => {
        console.log("error logging out ", error);
      })
      .finally(() => {
        setJwtToken(null);
        setCurrentUser(null);
        toggleRefresh(false);
        setCurrentCompany(null);
        setProfilePic(null);
        setTypesData(null);
        setCompanyData(null);
        setGlobalCompanyNames(null);
        setRateSheetData(null);
        setFuelSurchargeData(null);
        setAssetRateSheets(null);
        setProjectData(null);
      });
    setIsPending(false);
    navigate("/login");
  };

  const toggleRefresh = useCallback(
    (status) => {
      if (status) {
        let i = setInterval(() => {
          const requestOptions = {
            method: "GET",
            credentials: "include",
          };
          fetch(`${process.env.REACT_APP_BACKEND}/refresh`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
              if (data.access_token) {
                // should be refresh token
                setJwtToken(data.access_token);
                setAuthError(null);
              }
            })
            .catch((err) => {
              console.log("user is not logged in");
            });
        }, 1200000);
        setTickInterval(i);
      } else {
        setTickInterval(null);
        clearInterval(tickInterval);
      }
    },
    [tickInterval, setJwtToken, setAuthError],
  );

  useEffect(() => {
    if (JwtToken === "") {
      const requestOptions = {
        method: "GET",
        credentials: "include",
      };
      fetch(`${process.env.REACT_APP_BACKEND}/refresh`, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.access_token) {
            setJwtToken(data.access_token);
            toggleRefresh(true);
            setAuthError(null);
          }
        })
        .catch((err) => {
          console.log("user is not logged in");
          navigate("/login");
        });
    }
  }, [JwtToken, toggleRefresh, setJwtToken, navigate, setAuthError]);

  // get data
  const hideSettings = () => {
    setShowSettings(false);
  };

  return (
    <div className="App">
      {JwtToken &&
        !authError &&
        currentCompany &&
        currentUser &&
        authStatus && <Sidebar updateShow={setShowSettings} />}
      {showSettings &&
        JwtToken &&
        !authError &&
        currentCompany &&
        currentUser && <SettingsSidebar jwtToken={JwtToken} />}
      <div className="container-fluid">
        {messageTrigger && (
          <MessageCard
            errorMessage={pageError}
            successMessage={successMessage}
          />
        )}
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <div className="navbar-header">
              {JwtToken && !authError && authStatus ? (
                <div>
                  <span className="navbar-brand">
                    <div className="text-center">
                      <div className="row justify-content-start">
                        <div
                          className="col-1"
                          style={{
                            margin: "0 0 0 5px",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <NavLink
                            to="/"
                            className="qwikr"
                            onClick={hideSettings}
                          >
                            q
                          </NavLink>
                        </div>
                        <div
                          className="col-2"
                          style={{ margin: "10px 0 0 10px" }}
                        >
                          <NavLink
                            to="/"
                            className="qwikr"
                            onClick={hideSettings}
                          >
                            w
                          </NavLink>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "0 0 0 2px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <NavLink
                            to="/"
                            className="qwikr"
                            onClick={hideSettings}
                          >
                            i
                          </NavLink>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "10px 5px 0 0",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <NavLink
                            to="/"
                            className="qwikr"
                            onClick={hideSettings}
                          >
                            k
                          </NavLink>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "0 0 0 20px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <NavLink
                            to="/"
                            className="qwikr"
                            onClick={hideSettings}
                          >
                            r
                          </NavLink>
                          <span className="version">
                            {process.env.REACT_APP_VERSION}
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              ) : (
                <div>
                  <span className="navbar-brand">
                    <div className="text-center">
                      <div className="row justify-content-start">
                        <div
                          className="col-1"
                          style={{
                            margin: "0 0 0 5px",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <h4 className="qwikr">q</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{ margin: "10px 5px 0 10px" }}
                        >
                          <h4 className="qwikr">w</h4>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "0 20px 0 2px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <h4 className="qwikr">i</h4>
                        </div>
                        <div
                          className="col-1"
                          style={{
                            padding: "10px 5px 0 10px",
                            transform: "rotate(-20deg)",
                          }}
                        >
                          <h4 className="qwikr">k</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{
                            padding: "0 0 0 25px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <h4 className="qwikr">r</h4>
                        </div>
                        <div
                          className="col-2"
                          style={{
                            padding: "50px 0 0 10px",
                            transform: "rotate(10deg)",
                          }}
                        >
                          <span className="version">
                            {process.env.REACT_APP_VERSION}
                          </span>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
              )}
            </div>
            {(!JwtToken || !authStatus) && (
              <ul className="nav navbar-nav navbar-right">
                <li>
                  <Link to="login">Login</Link>
                </li>
                <li>
                  <Link to="signup">Signup</Link>
                </li>
              </ul>
            )}
            {JwtToken && authStatus && (
              <div className="d-flex flex-row mb-3">
                <div className="p-2">
                  {!isPending && (
                    <button className="propx-btn" onClick={logout}>
                      Logout
                    </button>
                  )}
                  {isPending && (
                    <button className="propx-btn" disabled>
                      Logging Out...
                    </button>
                  )}
                </div>
                {showTeam && (
                  <img
                    src={Collapse}
                    className="show-teams"
                    onClick={() => setShowTeam(false)}
                    alt="collapse"
                  />
                )}
                {!showTeam && (
                  <img
                    src={Expand}
                    className="show-teams"
                    onClick={() => setShowTeam(true)}
                    alt="expand"
                  />
                )}
              </div>
            )}
          </div>
        </nav>
        <Outlet
          context={{
            setShowSettings,
            toggleRefresh,
            fscPending,
          }}
        />
      </div>
      {JwtToken && showTeam && <OnlineUsers />}
    </div>
  );
}

export default App;
